<template>
  <Modal
    v-model="_value"
    width="400"
    title="配件信息分配分组"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form v-if="positioningDeviceFittingList.length > 0" ref="loginForm" :model="positioningDeviceFittingList">
      <div v-for="item in positioningDeviceFittingList">
        <FormItem prop="encryptionChipNumber" label="配件信息">
          <label style="display: inline-block;">{{item.encryptionChipNumber}}</label>
          <label style="display: inline-block;">{{item.positioningDeviceFittingsType.name}}</label>
        </FormItem>
      </div>
      <FormItem prop="name" label="分组信息">
        <Select class="field" v-model="positioningDeviceFitting.userGroupId">
          <Option v-for="item in userGroups" :value="item.id" :key="item.name">{{item.name}}</Option>
        </Select>
      </FormItem>
    </Form>
    <Form v-else ref="loginForm" :model="positioningDeviceFitting">
      <FormItem prop="name" label="分组信息">
        <Select class="field" v-model="positioningDeviceFitting.userGroupId">
          <Option v-for="item in userGroups" :value="item.id" :key="item.name">{{item.name}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'positioningdevicefittingchangeusergroupmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      userGroups: [
        { name: '中山', id: 1 },
        { name: '江门', id: 2 }
      ],
      positioningDeviceFitting: {
        id: null,
        userGroupId: null
      },

      positioningDeviceFittingList: [],
      positioningDeviceFittingIds: []
    }
  },
  methods: {
    ...mapActions([
    ]),
    onOk () {
      if (this.positioningDeviceFittingList != null && this.positioningDeviceFittingList.length > 0) {
        store.dispatch('PositioningDeviceFittingServ_BatchChangeGroup', {
          params:
            {
              ids: this.positioningDeviceFittingIds,
              userGroupId: this.positioningDeviceFitting.userGroupId
            },
          urlparams: null
        }).then(() => {
          this.$Message.success('分配配件信息分组成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '指派安装员',
          content: '<p>确认分配SIM卡分组</p>',
          onOk: () => {
            store.dispatch('PositioningDeviceFittingServ_ChangeGroup', {
              params: {
                id: this._initValue,
                userGroupId: this.positioningDeviceFitting.userGroupId
              }
            }).then(() => {
              this.$Message.success('分配配件信息分组成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        console.log(this._listValue)
        this.positioningDeviceFittingList = this._listValue
        this.positioningDeviceFittingIds = []
        if (this.positioningDeviceFittingList != null && this.positioningDeviceFittingList.length > 0) {
          this.positioningDeviceFittingList.forEach(item => {
            this.positioningDeviceFittingIds.push(item.id)
          })
        } else {
          this.positioningDeviceFittingIds = []

          this.positioningDeviceFitting.id = null
          this.positioningDeviceFitting.userGroupId = null

          let positioningDeviceFittingId = this._initValue
          if (positioningDeviceFittingId) {
            store.dispatch('PositioningDeviceFittingServ_GetDetail', {
              params: { id: positioningDeviceFittingId }
            }).then(() => {
              this.positioningDeviceFitting = store.getters.get_PositioningDeviceFitting_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
